<!-- ブックをis_expired=trueにするダイアログ-->
<template>
  <div>
    <ItemDialog ref="bookChangeToUsed" imageType="alert" :initialOpen="false">
      <template v-slot:content-area>
        <h2>利用を終了すると効力を失います</h2>
        <p class="text-center">本当に利用を終了しますか？</p>
      </template>

      <template v-slot:button-area>
        <ItemButton
          label="OK"
          actionType="btn-primary"
          @clicked="passChangeToUsed()"
        />
        <ItemButton
          label="キャンセル"
          actionType="btn-cancel"
          @clicked="closeDialog"
        />
      </template>
    </ItemDialog>

    <!-- ローディングダイアログ -->
    <DialogLoading ref="DialogLoading" />
  </div>
</template>

<script>
import DialogLoading from "@/views/Components/Organisms/Common/Dialog/DialogLoading";

import { computed, ref } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";

import API from "@/API";

export default {
  name: "DialogBookChangeToUsed",
  components: {
    DialogLoading: DialogLoading,
  },
  setup() {
    const store = useStore();
    const route = useRoute();

    const book = computed(() => store.getters["ticketing/book"]);

    const bookChangeToUsed = ref(null);
    const DialogLoading = ref(null);

    const openDialog = () => {
      bookChangeToUsed.value.open();
    };

    const closeDialog = () => {
      bookChangeToUsed.value.close();
    };

    const passChangeToUsed = async () => {
      closeDialog();
      DialogLoading.value.openDialog();
      await API.usedBook(book.value.id);
      await API.getMyticketDetail(route.params.book_group_id);

      DialogLoading.value.closeDialog();
    };

    return {
      bookChangeToUsed,
      DialogLoading,
      passChangeToUsed,
      openDialog,
      closeDialog,
    };
  },
};
</script>
